import {useConfig} from '@aboutyou/config';
import {useInViewEffect} from '@aboutyou/ui-components';
import {useRef, useState} from 'react';

export const useAutoHideFollowBrandLabel = () => {
  const {device} = useConfig();
  const [hideFollowBrandLabel, setHideFollowBrandLabel] = useState(false);
  const timerRef = useRef<NodeJS.Timeout>(undefined);

  const {ref} = useInViewEffect<HTMLLIElement>(
    inView => {
      if (inView) {
        timerRef.current = setTimeout(
          () => setHideFollowBrandLabel(true),
          5000,
        );
      } else {
        setHideFollowBrandLabel(false);
        clearTimeout(timerRef.current);
      }

      return () => {
        clearTimeout(timerRef.current);
      };
    },
    {
      threshold: 0.3,
      skip: device !== 'desktop',
    },
  );

  return {ref, hideFollowBrandLabel};
};
